module.exports = "/assets/data/873ff13870ff87f92aaa1e2f8f3a4b4a-NW3.data.json";